"use client"

import Link from "next/link"
import { useState } from "react"
import { Header } from "@/components/landrisk/header"
import { Footer } from "@/components/landrisk/footer"
import { HeroSection } from "@/components/landrisk/hero-section"
import { HowItWorks } from "@/components/landrisk/how-it-works"
import { FeaturesGrid } from "@/components/landrisk/features-grid"
import { UserTypes } from "@/components/landrisk/user-types"
import { ProfileModal } from "@/components/landrisk/profile-modal"
import { Button } from "@/components/ui/button"
import { Card, CardContent } from "@/components/ui/card"
import { User, Save } from "lucide-react"

export default function LandingPage() {
  const [profileModalOpen, setProfileModalOpen] = useState(false)

  return (
    <div className="flex min-h-screen flex-col">
      <Header onProfileClick={() => setProfileModalOpen(true)} />
      <main className="flex-1">
        <HeroSection />

        <section className="border-b border-border bg-muted/30 py-12">
          <div className="mx-auto max-w-7xl px-4 lg:px-8">
            <Card className="border-2 border-green-600/20 bg-green-600/5">
              <CardContent className="flex flex-col gap-4 py-8 sm:flex-row sm:items-center sm:justify-between">
                <div className="flex items-start gap-4">
                  <div className="flex size-12 shrink-0 items-center justify-center rounded-lg bg-green-600/20">
                    <User className="size-6 text-green-700" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-foreground">Save Your Results</h3>
                    <p className="mt-1 text-sm text-muted-foreground">
                      Create a profile to store historical reports and track multiple properties over time.
                    </p>
                  </div>
                </div>
                <Button
                  onClick={() => setProfileModalOpen(true)}
                  className="gap-2 shrink-0"
                  size="lg"
                >
                  <Save className="size-4" />
                  Create Profile
                </Button>
              </CardContent>
            </Card>
          </div>
        </section>

        <HowItWorks />
        <FeaturesGrid />
        <UserTypes />

        <section className="border-t border-border bg-gradient-to-b from-green-600/5 to-background py-20">
          <div className="mx-auto max-w-3xl px-4 text-center lg:px-8">
            <h2 className="text-balance text-3xl font-bold tracking-tight text-foreground sm:text-4xl">
              <span className="text-green-700">Before You Buy,</span> <span>Be Sure</span>
            </h2>
            <p className="mt-4 text-pretty text-lg text-muted-foreground leading-relaxed">
              Get a comprehensive risk report in minutes. Make informed decisions backed by data.
            </p>
            <Button asChild size="lg" className="mt-8 h-12 px-8 text-base">
              <Link href="/identify">Start Your Risk Assessment</Link>
            </Button>
          </div>
        </section>
      </main>
      <Footer />

      <ProfileModal open={profileModalOpen} onOpenChange={setProfileModalOpen} />
    </div>
  )
}
